import React from 'react';
import { AuthRoles } from "components/auth";

export const ManagementDriverConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/management_driver`,
            component: React.lazy(() => import('./ManagementDriver'))
        }
    ]
};